module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074ce_logo_200x200.76d1ef37.png";